import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PersonalInfoFormProps {
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  confirmPassword?: string;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  setEmail: (value: string) => void;
  setPassword?: (value: string) => void;
  setConfirmPassword?: (value: string) => void;
  disabled?: boolean;
  hideEmailPassword?: boolean;
}

export function PersonalInfoForm({
  firstName,
  lastName,
  email,
  password = "",
  confirmPassword = "",
  setFirstName,
  setLastName,
  setEmail,
  setPassword = () => {},
  setConfirmPassword = () => {},
  disabled = false,
  hideEmailPassword = false
}: PersonalInfoFormProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label htmlFor="firstName" className="text-[#004161] font-serif">First Name</Label>
          <Input
            id="firstName"
            type="text"
            placeholder="Enter your first name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            disabled={disabled}
            className="bg-transparent border-[#004161]/10 focus:border-[#004161]/20 focus:ring-0 transition-all duration-300 placeholder:text-[#004161]/40 rounded-xl font-serif"
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="lastName" className="text-[#004161] font-serif">Last Name</Label>
          <Input
            id="lastName"
            type="text"
            placeholder="Enter your last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            disabled={disabled}
            className="bg-transparent border-[#004161]/10 focus:border-[#004161]/20 focus:ring-0 transition-all duration-300 placeholder:text-[#004161]/40 rounded-xl font-serif"
          />
        </div>
      </div>

      {!hideEmailPassword && (
        <>
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-[#004161] font-serif">Email</Label>
        <Input
          id="email"
          type="email"
              placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={disabled}
              className="bg-transparent border-[#004161]/10 focus:border-[#004161]/20 focus:ring-0 transition-all duration-300 placeholder:text-[#004161]/40 rounded-xl font-serif"
        />
      </div>

          {setPassword && setConfirmPassword && (
            <>
              <div className="space-y-1.5">
                <Label htmlFor="password" className="text-[#004161] font-serif">Password</Label>
        <Input
          id="password"
          type="password"
                  placeholder="Create a password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={disabled}
                  className="bg-transparent border-[#004161]/10 focus:border-[#004161]/20 focus:ring-0 transition-all duration-300 placeholder:text-[#004161]/40 rounded-xl font-serif"
        />
      </div>

              <div className="space-y-1.5">
                <Label htmlFor="confirmPassword" className="text-[#004161] font-serif">Confirm Password</Label>
        <Input
          id="confirmPassword"
          type="password"
                  placeholder="Confirm your password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={disabled}
                  className="bg-transparent border-[#004161]/10 focus:border-[#004161]/20 focus:ring-0 transition-all duration-300 placeholder:text-[#004161]/40 rounded-xl font-serif"
        />
      </div>
    </>
          )}
        </>
      )}
    </div>
  );
}
